export const PREFIX = 'cyber-theme'
export const DOT_PREFIX = `.${PREFIX}`
